import BaseInput from "./components/Inputs/BaseInput.vue";
import BaseCheckbox from "./components/Inputs/BaseCheckbox.vue";
import BaseRadio from "./components/Inputs/BaseRadio.vue";
import BaseDropdown from "./components/BaseDropdown.vue";
import BaseButtonLabel from "./components/Inputs/BaseButtonLabel.vue";
import ShareIcon from "./components/ShareIcons/ShareIcon.vue";
import Card from "./components/Cards/Card.vue";
import Loader from "./components/Loader/Loader.vue";
import BaseModal from "src/components/Modal/BaseModal.vue";
import InstallPrompt from "src/components/InstallPrompt.vue";


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseButtonLabel.name, BaseButtonLabel);
    Vue.component(BaseModal.name, BaseModal);
    Vue.component("share-icon", ShareIcon);
    Vue.component("card", Card);
    Vue.component("loader", Loader);
    Vue.component("install-prompt", InstallPrompt);
  },
};

export default GlobalComponents;
